import React from "react"
import { WhiteDiv } from "./whitediv"

interface OfficerProps {
  role: string
  name: string
  college: string
  jobDesc: string
  email: string
  picture?: any
}
export const OfficerBox: React.FC<OfficerProps> = ({
  role,
  name,
  college,
  jobDesc,
  email,
  picture,
}) => (
  <div style={{ margin: "1rem 1rem 1rem 1rem", width: "22rem" }}>
    <WhiteDiv>
      <h3 style={{ textAlign: "center" }}>{role}</h3>
      <p style={{ textAlign: "center" }}>{`${name} (${college})`}</p>
      {picture ? (
        <div
          style={{
            backgroundImage: `url(${picture})`,
            width: "15rem",
            height: "18rem",
            backgroundPosition: "center",
            backgroundSize: "cover",
            margin: "auto",
          }}
        />
      ) : null}
      <p style={{ textAlign: "center" }}>
        {jobDesc}
        <br />
        <a href={`mailto:${email}`}>{email}</a>
      </p>
    </WhiteDiv>
  </div>
)
